import React, { createContext, useContext, useState, useEffect } from 'react';
import { defaultSiteData } from '../data/defaultSiteData';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const [siteData, setSiteData] = useState(() => {
        const savedData = localStorage.getItem('mediseller_pharmacy_data');
        if (savedData) {
            try {
                const parsed = JSON.parse(savedData);
                // Force reset if version mismatch or missing version
                if (!parsed.version || parsed.version !== defaultSiteData.version) {
                    console.warn(`MEDISELLER: Version mismatch! Local: ${parsed.version}, Default: ${defaultSiteData.version}. Resetting...`);
                    localStorage.clear(); // Clear EVERYTHING
                    return defaultSiteData;
                }
                // Merge with defaults to handle new fields added in updates
                return { ...defaultSiteData, ...parsed };
            } catch (e) {
                console.error('Error parsing site data from localStorage', e);
                return defaultSiteData;
            }
        }
        return defaultSiteData;
    });

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('mediseller_admin_auth') === 'true';
    });

    const saveSiteData = (newData) => {
        setSiteData(newData);
        localStorage.setItem('mediseller_pharmacy_data', JSON.stringify(newData));
    };

    const resetSiteData = () => {
        setSiteData(defaultSiteData);
        localStorage.removeItem('mediseller_pharmacy_data');
    };

    const login = (username, password) => {
        if (username === siteData.adminAuth.username && password === siteData.adminAuth.password) {
            setIsAuthenticated(true);
            localStorage.setItem('mediseller_admin_auth', 'true');
            return true;
        }
        return false;
    };

    const logout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem('mediseller_admin_auth');
    };

    return (
        <AdminContext.Provider value={{ siteData, saveSiteData, resetSiteData, isAuthenticated, login, logout }}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdminContext = () => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error('useAdminContext must be used within an AdminProvider');
    }
    return context;
};
